// extracted by mini-css-extract-plugin
module.exports = {"embedWrapper":"Embed-module--embed-wrapper--1cW-y","cinematic":"Embed-module--cinematic--S-7fn"};